import Cookies, { CookieGetOptions } from "universal-cookie";

const cookies = new Cookies();

export function getCookie(name: string, options?: CookieGetOptions) {
  return cookies.get(name, options) || "";
}
